import React, { useState } from "react";
import { Button, CircularProgress } from "@mui/material";
import { MyLocation } from "@mui/icons-material";
import { toast } from "react-toastify";

export default function GetCurrentLocation({ onLocationRetrieved }) {
  const [loading, setLoading] = useState(false);

  const handleClick = () => {
    if (!navigator.geolocation) {
      toast.error("Geolocation is not supported by your browser");
      return;
    }

    setLoading(true);

    navigator.geolocation.getCurrentPosition(
      (position) => {
        setLoading(false);
        onLocationRetrieved({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
      },
      (error) => {
        setLoading(false);
        console.error(error);
        toast.error("Unable to fetch current location");
      },
      {
        enableHighAccuracy: false, 
        timeout: 8000, 
        maximumAge: 300000,
      },
    );
  };

  return (
    <Button
      variant="outlined"
      onClick={handleClick}
      disabled={loading}
      startIcon={loading ? <CircularProgress size={16} /> : <MyLocation />}
    >
      {loading ? "Fetching..." : "Get Current Location"}
    </Button>
  );
}
